import { render, staticRenderFns } from "./label-set.vue?vue&type=template&id=fb670100&scoped=true"
import script from "./label-set.vue?vue&type=script&lang=js"
export * from "./label-set.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb670100",
  null
  
)

export default component.exports